import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useReduxState } from 'hooks';
import { Tooltip } from 'components/common';

interface Props {
  comment?: string | null;
}

const GrantorCommentIcon = ({ comment }: Props) => {
  const { messages, theme } = useReduxState();

  if (!comment) return null;

  return (
    <>
      <Tooltip
        childrenWrapInDiv={false}
        content={comment}
        contentStyle={{ lineHeight: 1.3, padding: '8px 12px' }}
        isLight={true}
      >
        <button
          aria-label={messages.commonComment}
          className="grantor-comment-icon"
          type="button"
        >
          <FontAwesomeIcon icon="comment" />
        </button>
      </Tooltip>

      <style jsx>{`
        .grantor-comment-icon {
          background: transparent;
          border: 0;
          color: ${theme.textColorLighter};
          cursor: pointer;
          font-family: inherit;
          font-size: 1.2rem;
          line-height: 1;
          margin-left: 4px;
          opacity: 0.5;
          padding: 0;
          position: relative;
          top: -1px;
          vertical-align: middle;
        }
        .grantor-comment-icon::before {
          content: '';
          height: 24px;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 24px;
        }
        .grantor-comment-icon:hover,
        .grantor-comment-icon:focus-visible {
          opacity: 1;
        }
      `}</style>
    </>
  );
};

export default GrantorCommentIcon;
